export const dialogOverlay = {
  top: '15% !important',
  left: 'calc(50% - 268px)',
  transform: 'none',
  width: 536,
};
